export default __webpack_public_path__ + "static/media/45t.b80540ac.jpg";